
 
document.addEventListener("DOMContentLoaded", function () {
    var atcElement = document.querySelector(".sticky-cta");

    // Primo elemento: quello originale
    var productSubmitButton = document.getElementById('p-img-start-sticky');

    // Secondo elemento: quello che rende lo sticky invisibile se anche solo parzialmente visibile
    // var visibilityTarget = document.querySelector('.p-cta-wrapper.mar-top-20');
    var visibilityTarget = document.getElementById('p-img-start-sticky');
    

    var desktopPosition = "bottom";
    var mobilePosition = "bottom";

    function updateStickyPosition() {
        var isMobile = window.innerWidth < 750;
        var position = isMobile ? mobilePosition : desktopPosition;
        // atcElement.style.top = position === "top" ? "-200px" : "auto";
        atcElement.style.bottom = position === "bottom" ? "-200px" : "auto";
    }

    function isElementPartiallyInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function isElementCompletelyAboveViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.bottom < 0;
    }

    // updateStickyPosition();
    // window.addEventListener("resize", updateStickyPosition);

    
    window.addEventListener("scroll", function () {
        
        const submitOutOfView = isElementCompletelyAboveViewport(productSubmitButton);
        const visibilityTriggerVisible = isElementPartiallyInViewport(visibilityTarget);
        
        if (submitOutOfView && !visibilityTriggerVisible) {
            atcElement.classList.add("show");
        } else {
            atcElement.classList.remove("show");
        }
    });


    
    document.querySelectorAll('.cta-2, .cta-1-btn').forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const targetId = link.getAttribute('href').substring(1);
            document.getElementById(targetId).scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    });


    function handle_vid() {
        const cta_wr = document.getElementById('cta-wrapper');
        const online_cta = document.getElementById('onl_check');
        const gallery = document.querySelectorAll('.prod-img');
        const firstVarInput = document.querySelector('input[type="radio"][form][data-var-id]');

        if (!cta_wr || gallery.length === 0) return;

        online_cta.href = `https://roman-active.com/cart/${firstVarInput.dataset.varId}:1`;

        document.addEventListener('change', function (e) {
            const sw = e.target;

            if (!sw.matches('input[type="radio"][form][data-var-id]')) return;

            cta_wr.dataset.vChecked = sw.dataset.varId;
            online_cta.href = `https://roman-active.com/cart/${sw.dataset.varId}:1`;
            toggleImg(sw.dataset.varId);
        });

        function toggleImg(varID_toShow) {
            let isIN = null;
            console.log('toggle img');
            
            gallery.forEach((wr, id) => {
            if (wr.dataset.varId == varID_toShow) {
                isIN = id;
                wr.classList.toggle('p-img-show');
            } else {
                wr.classList.toggle('p-img-show');
            }
            });
        }
    }

    handle_vid();

                
    
});



